import { createClient } from '@supabase/supabase-js';

// Webvonk Platform Database - authentication and user management
const WEBVONK_URL = 'https://swxfaqoftmwphbparotf.supabase.co';
const WEBVONK_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN3eGZhcW9mdG13cGhicGFyb3RmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk1MjY1OTQsImV4cCI6MjA5NTEwMjU5NH0.IZZAiD-ndE_CvkuY3E44N8Sm7u1EXnsYaYnCda6R-v4';

// KMFC-shop Database - orders, products, etc.
const KMFC_URL = 'https://fmdrwkyqeewofhytxkiw.supabase.co';
const KMFC_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZtZHJ3a3lxZWV3b2ZoeXR4a2l3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk1MzA1MjUsImV4cCI6MjA5NTEwNjUyNX0.Mbi3O0AGDwmabkr84bgoRI2D9nde4QCxcUcaChSaNZE';

// Koffiereparatie Geleen Database - machines, contact submissions
const KOFFIE_URL = 'https://jrjosjcaozgtjdbeohki.supabase.co';
const KOFFIE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impyam9zamNhb3pndGpkYmVvaGtpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTI5NTAxMDksImV4cCI6MjEwODUyNjEwOX0.ryUriQC6TDiN81fSWaQpWL2_9eOWANYIHzA6wluK320';

export const webvonkClient = createClient(WEBVONK_URL, WEBVONK_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});

const kmfcClient = createClient(KMFC_URL, KMFC_ANON_KEY, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
  },
});

export const getKmfcClient = () => kmfcClient;

// No-op for backwards compatibility — kmfcClient is now hardcoded
export async function initKmfcClient() {
  return kmfcClient;
}

export const koffieClient = createClient(KOFFIE_URL, KOFFIE_ANON_KEY, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
  },
});
